import React, { useContext, useRef, useState } from "react";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { observer } from "mobx-react-lite";
import { Context } from "../../..";
import smile from "../../../utils/smile.svg";
import Send from "../../../utils/send.svg";

const ChatMessageLine = observer(({ roomId, sendMessage, sendJsonMessage}) => {
    const { user } = useContext(Context);
    const [emojiPanelVisible, setEmojiPanelVisible] = useState(false);
    const [input, setInput] = useState('');
    const inputRef = useRef();
    const [showEmojis, setShowEmojis] = useState(false);

    const handleSendMessage = () => {
        if (input.trim()) {
            const message = {
                message: input,
                sender_id: user.user.id,
                sender_name: user.user.first_name,
                timestamp: new Date().toISOString(),
            };
            console.log('Sending message:', message);

            // Отправка сообщения обратно в родительский компонент (ChatRoom)
            sendMessage(message);
            sendJsonMessage({message:input, type: 'text'})
            setInput('');  // Очистить поле ввода
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSendMessage();
        }
    };

    const addEmoji = (emoji) => {
        setInput((prev) => prev + emoji.native);
        setShowEmojis(false);
    };

    return (
        <div className="flex justify-center">
            <div className="fixed bottom-3 flex items-center bg-white rounded-[38px] shadow-lg w-full max-w-2xl">
                <div className="relative pl-4 pr-2">
                    <button
                        onClick={() => setShowEmojis(!showEmojis)}
                        className="p-2 hover:bg-gray-100 rounded-full"
                        aria-label="Open emoji picker"
                    >
                        <img className="text-xl text-[#9B9BAA]" src={smile} alt=""/>
                    </button>
                    {showEmojis && (
                        <div className="absolute bottom-12 left-0 z-50">
                            <Picker data={data} onEmojiSelect={addEmoji} theme="light"/>
                        </div>
                    )}
                </div>

                <input
                    type="text"
                    value={input}
                    onChange={(e) => setInput(e.target.value)}
                    placeholder="Введите сообщение"
                    className="flex-1 font-semibold py-3 rounded-[38px] focus:outline-none text-[#9B9BAA] placeholder-gray-400"
                    onKeyDown={handleKeyPress}
                    aria-label="Message input"
                />

                <button
                    onClick={handleSendMessage}
                    className="p-2 text-white rounded-lg max-w-4.3"
                    aria-label="Send message"
                >
                    <img src={Send} alt=""/>
                </button>
            </div>
        </div>
    );
});

export default ChatMessageLine;